import React, { useEffect, useState } from 'react'
import {
  GetTagMethodsContainer,
  GetTagSection,
  GetTagSectionNumCircle,
  GetTagSectionTitle,
  GetTagSectionContent,
  InstructionSection,
} from './GetTagMethods.styled'
import { RadioMethodSelection } from './RadioMethodsSelection/RadioMethodsSelection'
import {
  METHODS_SELECTION_OPTIONS,
  RadioMethodsSelection,
  TagMethods,
} from './RadioMethodsSelection/RadioMethodsSelection.models'
import { useTranslation } from 'react-i18next'
import { InstructionRenderer } from './Instructions/InstructionRenderer'
import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import { Domain } from 'Types/Domain'
interface GetTagMethodsProps {
  tagUrl: string
  bzState?: number | null
  isWordpress?: boolean
  initialMethod?: TagMethods
  domainAddress: string | undefined
  closeModal: () => void
  domain: Domain | undefined
}

export const GetTagMethods = ({
  tagUrl,
  bzState,
  initialMethod,
  closeModal,
  domain,
}: GetTagMethodsProps) => {
  const { t } = useTranslation('domainManagement')

  const [method, setMethod] = useState<TagMethods>(
    METHODS_SELECTION_OPTIONS()[0].value as TagMethods
  )

  const { data: plans } = useGetPackagingLimits()

  useEffect(() => {
    if (initialMethod) {
      setMethod(initialMethod)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plans?.botZappingAllowed, initialMethod])

  return (
    <GetTagMethodsContainer>
      <GetTagSection>
        <GetTagSectionTitle>
          <GetTagSectionNumCircle>1</GetTagSectionNumCircle>
          {t('get_tag_modal.title_methods')}
        </GetTagSectionTitle>
        <GetTagSectionContent>
          <RadioMethodSelection
            options={METHODS_SELECTION_OPTIONS() as RadioMethodsSelection[]}
            selectedValue={method}
            onChange={setMethod}
          />
        </GetTagSectionContent>
      </GetTagSection>
      <InstructionSection>
        <GetTagSectionTitle css={{ marginLeft: '40px' }}>
          <GetTagSectionNumCircle>2</GetTagSectionNumCircle>
          {t('get_tag_modal.title_instructions')}
        </GetTagSectionTitle>
        <GetTagSectionContent>
          <InstructionRenderer
            domain={domain}
            tagMethod={method}
            tagUrl={tagUrl}
            closeModal={closeModal}
            bzState={bzState}
          />
        </GetTagSectionContent>
      </InstructionSection>
    </GetTagMethodsContainer>
  )
}
